import getReduced from '@pkg/entities/snapshots/utils/getReduced';
import { DesignEntity, DesignLevel } from '@/lib/enums';

export function getManagedEntitiesForRole(managed, snapshot, roleId) {
  const reduced = getReduced(snapshot, {
    type: DesignLevel.MANAGER,
    uuid: roleId,
  });

  if (reduced.entities?.people) {
    for (const id in reduced.entities.people) {
      managed[DesignEntity.PERSON].add(id);
    }
  }

  if (reduced.entities?.groups) {
    for (const id in reduced.entities.groups) {
      managed[DesignEntity.GROUP].add(id);
    }
  }

  if (reduced.entities?.roles) {
    for (const id in reduced.entities?.roles) {
      if (id !== roleId) {
        managed[DesignEntity.ROLE].add(id);
      }
    }
  }

  if (reduced.entities?.activities) {
    for (const id in reduced.entities.activities) {
      if (reduced.entities.activities[id].owner_uuid !== roleId) {
        managed[DesignEntity.ACTIVITY].add(id);
      }
    }
  }
}

/**
 * @param {Object} snapshot
 * @param {Object} relations
 * @param {String} personId
 * @returns {Object}
 */
export default function getManagedEntities(snapshot, relations, personId) {
  const managed = {
    [DesignEntity.GROUP]: new Set(),
    [DesignEntity.ROLE]: new Set(),
    [DesignEntity.PERSON]: new Set(),
    [DesignEntity.ACTIVITY]: new Set(),
  };

  if (!snapshot || !relations || !personId) {
    return managed;
  }

  const assignedRoles =
    relations[DesignEntity.PERSON].get(personId)?.[DesignEntity.ROLE] ?? [];

  const managerRoles = assignedRoles.filter((roleId) => {
    const role = relations[DesignEntity.ROLE].get(roleId);
    return role?.is_manager;
  });

  for (const roleId of managerRoles) {
    getManagedEntitiesForRole(managed, snapshot, roleId);
  }

  return managed;
}
